<template>
  <div style="overflow-y: scroll; height: 50vh" v-if="image!==null" ref="divHeight">
    <span ref="spanHeight" :style="'height: '+height">
      <!--      <img ref="invoiceImage" src="https://i.picsum.photos/id/237/200/300.jpg" class="image">-->
      <div v-if="loading">
        <Loading />
      </div>
      <span>
        <img v-if="!pdf" ref="invoiceImage" :src="'/api/uploads/' + image" class="image" :style="{ display: displayImage, width: width }" @load="finishLoading()">
        <div>
          <pdf v-if="pdf" ref="invoiceImage" class="image" :style="{ display: displayImage, width: pdfWidth }" :src="'/api/uploads/' + image" @loaded="finishLoading" />
        </div>
      </span>
    </span>
  </div>
</template>

<script>
import Loading from "../Loading";
import pdf from 'vue-pdf';

export default {
    name: "InvoiceImage",
    components: {Loading, pdf},
    props: {
        image: { type: String, default: null },
        height: { type: String, default: '100%' },
        width: { type: String, default: 'undefined' },
    },
    data () {
        return {
            pdf: false,
            displayImage: "none",
            loading: true,
            pdfWidth: '500px'
        };
    },
    created ()  {
        const extension = this.image.split('.').pop().toLowerCase();
        if (extension === 'pdf') {
            this.pdf = true;
        }
        this.loading = true;
        this.displayImage = "none";
    },
    methods: {
        finishLoading () {
            this.loading = false;
            this.displayImage = "block";
            this.pdfWidth = '100%';//this.$refs.divHeight.clientHeight * 0.7 + 'px'; // 0.7 is the aspect ratio of A4 due a bug in vue-pdf we must set the with supposing that tha invoice is an A4
        }
    }
};
</script>

<style scoped>
  .image{
    display: block;
    height: 100%;
    margin: auto;
  }
</style>
